import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import "../App.css";
import FeedbackForm from "../components/FeedbackForm";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { RiMenu2Line } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import logo from '../assets/Deli_Logo.svg'
import { useParams } from 'react-router-dom';
import ImageCarousel from "../components/ImageCarousel";
import { CiHeart, CiRuler } from "react-icons/ci";
import { HiOutlineShare } from "react-icons/hi";
import { LiaBedSolid } from "react-icons/lia";
import { TbBath } from "react-icons/tb";
import { IoIosPricetag, IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";
import { LuCalendarDays } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import NearbyCard from "../components/NearbyCard";
import { capitalizeFirstLetter, isImageURL } from "../utils/helpers";
import ShareListing from "../components/ShareListing";
import {sendListingActionRequest, getClients, createClient, addClientNote, updateClientNote, deleteClientNote, unsaveClientList, saveClientList} from '../utils/apiHandler';
import PopUpNewClient from "../components/PopUpNewClient";
import { toast } from "react-toastify";
import { FiStar } from "react-icons/fi";
import { IoMdCheckmark } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { CgNotes } from "react-icons/cg";
import NotesCard from '../components/NotesCard';
import AgentSidebar from "../components/landingPage/AgentSidebar";
import Arrow from "../assets/landingPage/arrow"
import AgentSidebarMobile from "../components/landingPage/AgentSidebarMobile";
import ListingBroker from "../components/landingPage/ListingBroker";


const COLOR_PAIRS = {
  'hospital': '#FF9F43',
  'airport': '#BB86FC',
  'park': '#ECB22E',
  'supermarket': '#BF7BE9',
  'restaurant': '#7B68EE',
  'entertainment': '#1F75FF',
  'sports': '#F06236',
  'shopping': '#60BE2A',
  'services': '#AF1668',
  '*': '#78988C'
};

const randomViews = Math.floor(Math.random() * 1000) + 200, randomSaves = Math.floor(Math.random() * 140) + 1

const ListingDetails = () => {
    const [feedback, setfeedback] = useState(false);
    const [shareListing, setShareListing] = useState(false);
    const [closeSidebar, setCloseSidebar] = useState(false);
    const { user, getIdTokenClaims, isAuthenticated, getAccessTokenWithPopup, logout } = useAuth0();
    const [error, setError] = useState(null);
    const [listingDetail, setListingDetail] = useState(null);
    const [nearbyList, setNearbyList] = useState(null);
    const [showMoreNearby, setShowMoreNearby] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [showMoreFeature, setShowMoreFeature] = useState(false);
    const [showCopyPopup, setShowCopyPopup] = useState(false);
    const [isLiked, setIsLiked] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [clientPopUp,setClientPopUp] = useState(false);
    const { client } = useParams();
    const { queryParam } = useParams();
    const [clientId, setClientId] = useState(client);
    const [isFavorite, setIsFavorite] = useState(false);
    const [hasNotes, setHasNotes] = useState(false);
    const [isNewNote, setIsNewNote] = useState(false);
    const [newNoteText, setNewNoteText] = useState('');
    const [listingNotes, setListingNotes] = useState([]);

    const [openChatActive, setOpenChatActive] = useState(false)
    const [newClientActive, setNewClientActive] = useState(false)

    const handleCopy = () => {
      setShowCopyPopup(true);
      navigator.clipboard.writeText(listingDetail?.listing_id)
      setTimeout(() => setShowCopyPopup(false), 2000); // Hide the popup after 2 seconds
    };

    const closePanel = () => {
      setCloseSidebar(!closeSidebar);
    }

    const getClientsList = async () => {
      var data = await getClients(getIdTokenClaims, getAccessTokenWithPopup, logout);

      if(data){
        setClientList(data);
      }else{
        setClientList([]);
      }
    };
  
    useEffect(() => {
      if (window.innerWidth > 768) {
        setCloseSidebar(true);
        setShowMoreFeature(true);
      }
      if(isAuthenticated)
        getClientsList();

      getListingDetails();   
    }, []);

    const handleClientSubmit = async (clientName, clientDescription) =>{
      const response = await createClient(getIdTokenClaims, clientName, clientDescription , getAccessTokenWithPopup, logout);
      if(response){
        setClientPopUp(false);
        getClientsList();
        toast.success(
          'Client Added Succesfully',
          {
            style: {
              fontSize: '12px',
              width: '100%',
            }
          }
        );
      }else{
        toast.error(
          'We are unable to create client at moment, please try again in few minutes',
          {
            style: {
              fontSize: '12px', // Adjust the font size as needed
              width: '100%',
            },
            toastClassName: 'custom-toast',
          }
        );
      }
    }

    const getListingDetails = async () => {
      try {
        axios.get(`https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/answer/${queryParam}`)
          .then(response => {
            setListingDetail(response.data);
            setClientId(response.data?.client_id);
            setIsFavorite(response.data.is_saved ? true : false);
            setHasNotes(response.data.notes && response.data.notes.length > 0 ? true : false);
            setListingNotes(response.data.notes && response.data.notes.length > 0 ? response.data.notes : []);
            setNearbyList(Object.entries(response.data?.nearby).flatMap(([parentKey, array]) =>
              array.map(item => ({ ...item, parent_key: parentKey }))
            ).sort((a,b) => a.distance - b.distance));
          })
          .catch(error => {
            console.log(error, "There is some error fetching listing data");
          });
        setError(null);
      } catch (error) {
        console.log(error);
        setError("An error occurred. Please try again later.");
      }
    };

    const parseMultiValue = (value) => {
      if (value) {
        return value.replaceAll('{', '').replaceAll('}', '').replaceAll('"', '').split(',')
      }
      return [];
    }

    const handleLiked = async () =>{
      if(!isLiked){
        var res = await sendListingActionRequest(queryParam,'like');
        console.log(res);
        setIsLiked(true);
      }
    }

    const handleShare = async () => {
      var res = await sendListingActionRequest(queryParam,'share');
      setShareListing(true)
    }

    const handleFavoriteClick = () => {
      setIsNewNote(false);
      setIsFavorite(!isFavorite);
      saveUnsaveListing(!isFavorite,queryParam)
    }

    const handleNewNoteSave = async () =>{
      setIsNewNote(false)
      await handleUpdateNotes(null,newNoteText, queryParam);
      setNewNoteText('');
    }

    const handleUpdateNotes = async (noteId, note, answer_hash) =>{
      if(noteId){
        let result = await updateClientNote(noteId,note,getIdTokenClaims, getAccessTokenWithPopup, logout);
        if(result){
          const index = listingNotes.findIndex(note => note.id === noteId);
          if (index !== -1) {
          const updatedNotes = [...listingNotes];
          updatedNotes[index] = { ...updatedNotes[index], text: note };
          setListingNotes(updatedNotes);
          toast.success(
            'Note updated successfully'
          );
        }
      }
      }else{
        let result = await addClientNote(clientId,answer_hash,note,getIdTokenClaims, getAccessTokenWithPopup, logout);
        if(result){
          let obj = {
            id : result,
            text : note,
            last_changed : new Date().toLocaleString()
          }
          const updatedNotes = [...listingNotes, obj];
          setListingNotes(updatedNotes)
          toast.success(
            'Note successfully added to your notes'
          );
        }
      }
    }
  
    const handleDeleteNotes = async (noteId) =>{
     let result = await deleteClientNote(noteId,getIdTokenClaims, getAccessTokenWithPopup, logout);
     if(result){
      const updatedNotes = listingNotes.filter(note => note.id !== noteId);
      setListingNotes(updatedNotes);
      toast.success(
        'Note deleted successfully from to your notes'
      );
     }
    }
  
    const saveUnsaveListing = async (isFavorite, answerhash) => {
        if(isFavorite)
          await saveClientList(getIdTokenClaims, clientId, answerhash, getAccessTokenWithPopup, logout);
        else
          await unsaveClientList(getIdTokenClaims,clientId, answerhash, getAccessTokenWithPopup, logout);
    }

    const handleEditNoteSubmit = (noteid,text) => {
      handleUpdateNotes(noteid, text, queryParam);
  }

    return (
      <div className='bg-gradient-custom'>
        {feedback ? (
          <div className="absolute top-0 left-0 opacity-90 bg-[#3D4F6D] w-full h-screen  z-20"></div>
        ) : (
          ''
        )}
  
        {feedback && (
          <div className="relative ">
            <FeedbackForm setfeedback={setfeedback} />
          </div>
        )}

        {shareListing ? (
          <div className="absolute top-0 left-0 backdrop-blur bg-white/30 w-full h-screen z-20"></div>
        ) : (
          ''
        )}
  
        {shareListing && (
          <div className="relative ">
            <ShareListing setShareListing={setShareListing} />
          </div>
        )}
  
        <div className="flex h-vh h-dvh">
          { user &&
            <Sidebar setfeedback={setfeedback} closeSidebar={closeSidebar} setCloseSidebar={setCloseSidebar}
              userName={user?.first_name + user?.last_name} picture={user?.picture}
              clientsList={clientList} setClientPopUp={setClientPopUp}
              openChatActive={openChatActive}
              setOpenChatActive={setOpenChatActive}
              newClientActive={newClientActive}
              setNewClientActive={setNewClientActive}
            />
          }
  
          <div className="flex-1 flex flex-col">
            <div id="mobileNav" className="flex justify-between items-center bg-white p-4 lg:hidden border-b border-gray-200" style={{ zIndex: 10 }}>
              <div className="flex items-center gap-4">
                <img width={40} src={logo} alt="DELI" />
              </div>
              <div className={`${user ? '' : 'hidden'} flex justify-center`}>
                <button onClick={closePanel} className="mx-2">
                  {closeSidebar ? (
                    <AiOutlineClose size={28} />
                  ) : (
                    <RiMenu2Line size={28} />
                  )}
                </button>
              </div>
            </div>
            {clientPopUp && (
            <div className="relative mx-4 lg:mx-0">
              <PopUpNewClient 
                setClientPopUp={setClientPopUp}
                setNewClientActive={setNewClientActive}
                onSubmit= {handleClientSubmit}
                setOpenChatActive={() => true}
                clientId={clientId}
              />
            </div>
          )}
            <div className="flex-1 flex flex-col overflow-y-auto mb-[47px] lg:mb-[60px]">
              <div className={`hidden ${user && 'lg:block'} fixed top-[42%] ${closeSidebar ? 'left-[280px]' : 'left-[2px]'}`}>
                  <button onClick={closePanel} className="p-3 cursor-pointer">
                      <span className='w-1 h-6 bg-gray-400 block rounded-full'></span>
                  </button>
              </div>
              <div id="imageCarouselContainer" style={{position:"relative",width:"100%"}}>
                { listingDetail &&
                  <ImageCarousel media={listingDetail.media?.filter(obj => isImageURL(obj.url))} />
                }
              </div>
              <div className="relative flex flex-col lg:grid lg:grid-cols-[2fr_1fr] gap-1">
              <div id="listingDetailsContainer" className="lg:ms-20 lg:me-20 mt-[315px] lg:mt-[450px]">
                <div id="detailsHeader" className="ms-4 me-4 lg:ms-10 lg:me-10">
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div>
                    <div id="saleActiveDiv" className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mb-2"></div>
                      <span className="ml-2 font-medium text-sm mb-2">Active for Sale</span>
                    </div>
                    <div id="listingPrice" className="mt-2">
                      <span className="font-semibold text-4xl text-white bg-[#0062ff] p-1 rounded-md px-4">{listingDetail?.list_price}</span>
                    </div>
                  </div>
                  <div id="likeShareDiv" className="flex justify-end items-center gap-2">
                  { clientId && isFavorite && isAuthenticated ?  (
                    <div>
                    { isNewNote ? (
                      <div className='flex justify-end space-x-2'>
                        <div className={`p-3 rounded-full border-2 max-w-fit border-gray-700 text-gray-800 cursor-pointer transition-all duration-300 hover:border-green-500 hover:text-green-500`} onClick={handleNewNoteSave}>
                          <IoMdCheckmark size={20} />
                        </div>
                        <div className={`p-3 rounded-full border-2 max-w-fit border-gray-700 text-gray-800 cursor-pointer transition-all duration-300 hover:border-red-500 hover:text-red-500`} onClick={() => {setIsNewNote(false)}}>
                          <RxCross2 size={20} />
                        </div>
                      </div>
                      ):(
                        <div className='flex justify-end space-x-2'>
                          <div className={`p-3 rounded-full border-2 max-w-fit border-gray-700 text-gray-800 cursor-pointer transition-all duration-300 hover:border-[#0062FF] hover:text-[#0062FF]`} onClick={() => {setIsNewNote(true)}}>
                            <CgNotes size={20} />
                          </div>
                        </div>
                      )
                    }
                    </div>
                    ) : (<></>)}
                    { clientId && isAuthenticated &&  (
                    <div className='flex justify-end space-x-2'>
                      <div className={`p-3 rounded-full border-2 max-w-fit ${ isFavorite ? 'border-[#F6B554] text-[#F6B554]' : 'border-gray-700 text-gray-800'} cursor-pointer transition-all duration-300 hover:border-[#F6B554] hover:text-[#F6B554]`} onClick={handleFavoriteClick}>
                        <FiStar size={20} />
                      </div>
                    </div>
                    )}
                    <div className="p-3 rounded-full border-2 border-gray-700 text-gray-700 max-w-fit cursor-pointer transition-all duration-300 hover:border-[#0062FF] hover:text-[#0062FF]"
                      onClick={handleShare}
                    >
                      <HiOutlineShare size={22} />
                    </div>
                  </div>
                </div>
                <div>
                  <div id="listingAddress" className="mt-4 full-w">
                    <span className="font-light text-sm lg:text-lg">{listingDetail?.address}</span>
                  </div>
                  <div id="brokerAddress" className="mt-4 full-w">
                    <span className="font-light text-sm lg:text-lg font-roboto">Listing Provided Courtesy of {listingDetail?.broker_name ? listingDetail?.broker_name : "Broker Name"} - {listingDetail?.broker_address ? listingDetail?.broker_address : "Broker Address"}</span>
                  </div>
                  <div id="listingId" className="mt-2 bg-gray-200 max-w-fit p-2 text-sm rounded-md">
                    <div className="copy-button-container">
                      <span className="font-medium text-xs lg:text-sm cursor-pointer" onClick={handleCopy}>MLS #: {listingDetail?.listing_id}</span>
                      {showCopyPopup && <div className="copy-popup">Copied!</div>}
                    </div>
                  </div>
                </div>
                </div>
                {
                  clientId && (
                    <div className="NotesArea mt-6 lg:mt-10 ms-4 me-4 lg:ms-10 lg:me-10">
                        {
                          isNewNote && (
                            <textarea
                              onChange={(e) => setNewNoteText(e.target.value)}
                              className="w-full py-3 mt-4 px-4 rounded-2xl border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                              placeholder="Enter your notes please"
                              rows={6}
                              value= {newNoteText}
                            />
                          )
                        }

                        {
                          listingNotes && listingNotes.length > 0 ? (
                              <div>
                              {listingNotes.map((note, index) => (
                                  <NotesCard 
                                    key={index} 
                                    note={note}
                                    userName={user?.first_name + user?.last_name} 
                                    picture={user?.picture}
                                    rows = {2}
                                    updateNote={handleEditNoteSubmit}
                                    deleteNote={handleDeleteNotes}
                                    isAuthenticated={isAuthenticated}
                                  />
                              ))}
                                </div>
                              ) : (
                              <></>
                          )
                      }
                    </div>
                  )
                }
                <div id="bedBathDiv" className="grid grid-cols-3 lg:grid-cols-4 lg:ms-10 lg:me-10 ms-4 me-4 mt-5 lg:mt-8 border-t border-b py-2">
                  <div className="flex items-center gap-1 justify-center py-1">
                    <LiaBedSolid size={22} className="text-gray-800 me-1" />
                    <span className="font-medium">{listingDetail?.bedrooms}</span>
                    <span className="font-light">Beds</span>
                  </div>
                  <div className="flex items-center gap-1 justify-center py-1 border-l">
                    <TbBath size={22} className="text-gray-800 me-1" />
                    <span className="font-medium">{listingDetail?.bathrooms_total}</span>
                    <span className="font-light">Baths</span>
                  </div>
                  <div className="flex items-center gap-1 justify-center py-1 border-l">
                    <CiRuler size={26} className="text-gray-800 me-1" />
                    <span className="font-medium">{listingDetail?.living_area}</span>
                    <span className="font-light">Sq ft</span>
                  </div>
                  <div className="hidden lg:flex items-center gap-1 justify-center py-1 border-l">
                    <IoIosPricetag size={22} className="text-gray-800 me-1" />
                    <span className="font-medium">{listingDetail?.living_area == 0 ? 'N/A' : `$${Math.floor(Number(listingDetail?.list_price.replace('$', '').replaceAll(',',''))/listingDetail?.living_area)}`}</span>
                    <span className="font-light">Price/sqft</span>
                  </div>
                </div>
                <div className="mt-8 lg:mt-0 lg:hidden">
                  <AgentSidebarMobile  agentName={listingDetail?.user_details?.first_name + listingDetail?.user_details?.last_name} phoneNumber={listingDetail?.user_details?.mobile_number} emailAddress={listingDetail?.user_details?.email} imageURL={listingDetail?.user_details?.profile_image_url} />
                </div>
                <div id="listingDescription" className="flex flex-col bg-white px-4 py-7 lg:px-10 lg:py-12 rounded-md mt-7 lg:mt-12 gap-5 border">
                  <img src={logo} alt="DELI" className="w-14"/>
                  <h3 className="font-semibold text-3xl">Why this home?</h3>
                  <p className={`font-light ${showMore ? '' : 'line-clamp-4'} text-left`}>{listingDetail?.synopsis}</p>
                  {listingDetail?.synopsis.length > 350 && (
                    <button
                      className="text-blue-500 font-semibold cursor-pointer text-sm"
                      onClick={() => setShowMore(!showMore)}
                      type="button"
                    >
                      {showMore ? <span className="flex gap-1 items-center">Show Less <IoIosArrowUp/></span> : <span className="flex gap-1 items-center">Show More <IoIosArrowDown/></span>}
                    </button>
                  )}
                </div>
                <div id="statsDiv" className="grid grid-cols-3 lg:ms-10 lg:me-10 ms-4 me-4 mt-7 lg:mt-12 border-t border-b py-2">
                  <div className="flex flex-col lg:flex-row items-center gap-1 justify-center py-1">
                    <LuCalendarDays size={22} className="text-gray-800 me-1" />
                    <div>
                      <span className="font-medium">{listingDetail?.days_on_market}</span>
                      <span className="hidden lg:inline font-light"> Days on Market</span>
                      <span className="lg:hidden font-light"> Days</span>
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row items-center gap-1 justify-center py-1 border-l">
                    {/* check */}
                    <IoEyeOutline size={22} className="text-gray-800 me-1" />
                    <div>
                      <span className="font-medium">{listingDetail?.views ? listingDetail.views : randomViews}</span> 
                      <span className="hidden lg:inline font-light"> Total views</span>
                      <span className="lg:hidden font-light"> Views</span>
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row items-center gap-1 justify-center py-1 border-l">
                    {/* check */}
                    <CiHeart size={24} className="text-gray-950 me-1" />
                    <div>
                      <span className="font-medium">{listingDetail?.favorite ? listingDetail.favorite : 0}</span>
                      <span className="font-light"> Saves</span>
                    </div>
                  </div>
                </div>
                <div id="listingFeatures" className="grid grid-cols-1 lg:ms-0 lg:me-10 ms-9 me-4 mt-8 lg:mt-14 gap-4 lg:gap-7">
                  <h3 className="font-semibold text-2xl">Facts & features</h3>
                  <div id="featuresList" className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
                    <ul className="flex flex-col gap-4 lg:gap-8 shadow-sm pl-8 py-8 border">
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Bedrooms & bathrooms</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Bedrooms: {listingDetail?.bedrooms}</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Bathrooms: {listingDetail?.bathrooms_total}</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Full bathrooms: {listingDetail?.bathrooms_full}</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Half bathrooms: {listingDetail?.bathrooms_half}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Architectural style</span>
                        {parseMultiValue(listingDetail?.architectural_style).map(
                          (style, index) => (
                            <span key={style} className="inline-flex gap-2"> <Arrow className="mt-1" />{style}</span>
                          )
                        )}
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Rooms</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.rooms}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Stories</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.stories}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Garage</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.garage_spaces} space</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Location</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Country: </span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />City: {listingDetail?.city}</span>
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">Standard status</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.standard_status}</span>
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">Cooling</span>
                        {parseMultiValue(listingDetail?.cooling).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">Heating</span>
                        {parseMultiValue(listingDetail?.heating).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">View</span>
                        {parseMultiValue(listingDetail?.view).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">Utilities</span>
                        {parseMultiValue(listingDetail?.utilities).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-2`}>
                        <span className="font-medium text-lg">Exterior Feature</span>
                        {parseMultiValue(listingDetail?.exterior_features).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                    </ul>
                    <ul className={`${showMoreFeature ? "flex" : "hidden"} flex-col gap-4 lg:gap-8 shadow-sm pl-8 py-8 border`}>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Living Area</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.living_area} Sq ft</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Lot size</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.lot_size_acres} acres</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Year built</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.year_built}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Stories</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.stories}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Education</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />n/a</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Association</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Fee: {listingDetail?.association_fee}</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />Fee frequency: {listingDetail?.association_fee_frequency}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Association amenities</span>
                        {parseMultiValue(listingDetail?.association_amenities).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">MLS status</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.mls_status}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Postal city</span>
                        <span className="inline-flex gap-2"> <Arrow className="mt-1" />{listingDetail?.postal_city}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Sewer</span>
                        {parseMultiValue(listingDetail?.sewer).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Construction Materials</span>
                        {parseMultiValue(listingDetail?.construction_materials).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Vegetation</span>
                        <span>{listingDetail?.vegetation}</span>
                      </li>
                      <li className="flex flex-col gap-2">
                        <span className="font-medium text-lg">Water source</span>
                        {parseMultiValue(listingDetail?.water_source).map(
                          (item, index) => (
                            <span key={item} className="inline-flex gap-2"> <Arrow className="mt-1" />{item}</span>
                          )
                        )}
                      </li>
                    </ul>
                    <button
                        className="lg:hidden text-blue-500 font-semibold cursor-pointer text-sm"
                        onClick={() => setShowMoreFeature(!showMoreFeature)}
                        type="button"
                      >
                        {showMoreFeature ? <span className="flex gap-1 items-center">Show Less <IoIosArrowUp/></span> : <span className="flex gap-1 items-center">Show More <IoIosArrowDown/></span>}
                      </button>
                  </div>
                </div>
                <div id="nearbyPlacesDiv" className="flex flex-col px-4 py-6 lg:px-10 lg:py-12 border-t-2 lg:border-2 lg:rounded-sm mt-8 lg:mt-12 gap-5">
                  <h3 className="font-semibold text-2xl">Nearby</h3>
                  <div id="nearbyPlacesList" className="grid grid-cols-1 lg:grid-cols-3 gap-2">
                    {nearbyList && nearbyList.slice(0, showMoreNearby ? nearbyList.length : 6).map((place, index) => (
                      <NearbyCard key={index} type={capitalizeFirstLetter(place.parent_key)} name={place.name} 
                        address={place.address} distance={place.distance} 
                        walk={place.distance} drive={place.distance} color={COLOR_PAIRS[place.parent_key]}
                      />
                    ))}
                  </div>
                  {
                    nearbyList?.length > 6 &&
                    <div className='flex items-center justify-between lg:gap-16'>
                      <button
                        type="button"
                        className='text-sm py-2 rounded-lg flex justify-center items-center bg-[#0062FF] text-white px-5 transition-transform duration-300 hover:scale-105'
                        onClick={() => setShowMoreNearby(!showMoreNearby)}
                      >
                        {showMoreNearby ? 'Less places nearby' : 'More places nearby'} <IoIosArrowForward size={18}/>
                      </button>
                    </div>
                  }
                  </div>
                  {/* Listing Broker */}
                  <ListingBroker brokerName={listingDetail?.broker_name}
                    address={listingDetail?.broker_address}
                    city={listingDetail?.broker_city}
                    state={listingDetail?.broker_state}
                    phone={listingDetail?.broker_mobile_number}
                    />
                  {/* div inside main div for image carousel */}
                </div>
                
                <div className="hidden lg:block mt-[315px] lg:mt-[450px]">
                  <AgentSidebar agentName={listingDetail?.user_details?.first_name + listingDetail?.user_details?.last_name} phoneNumber={listingDetail?.user_details?.mobile_number} emailAddress={listingDetail?.user_details?.email} imageURL={listingDetail?.user_details?.profile_image_url} />
                </div>
                {/* new wrapper */}
              </div>
              {/* main div in which image carousel lies */}
            </div>
          </div>
        </div>
      </div>
    );
  
  };

  export default ListingDetails;